import PurchasePlanLoadErrorDialog from '@/components/modals/purchase-plan-load-error-dialog.vue'

export default {
  components: {
    PurchasePlanLoadErrorDialog,
  },
  methods: {
    isConnectionError(error) {
      if (!error) return false
      if (error.response) {
        return [502, 503, 504].includes(error.response.status)
      }
      return true
    },
    handlePurchasePlanLoadError(error, planId = null) {
      if (this.isConnectionError(error) && this.$refs.purchasePlanLoadErrorDialog) {
        return this.$refs.purchasePlanLoadErrorDialog.show(planId)
      }

      return this.failedAlert(error)
    },
  },
}
